import React from 'react';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

export const AutomationIcon = () => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			data-vc="automation-icon"
			{...ssrPlaceholderIdProp}
		>
			<path d="M14 5L10 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<path
				d="M14 5L7 12H17L10 19"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
